/* Enhance the automatically loaded native Aissie widget; keep its click handlers. */
(() => {
  const icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" stroke="%23232721" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5Z"/></svg>';
  let attempts = 0;

  function enhance() {
    const shadow = document.getElementById('aissie-chat')?.shadowRoot;
    if (!shadow) {
      // The vendor attaches its shadow root asynchronously. Stop if it fails to load.
      if (++attempts < 100) setTimeout(enhance, 200);
      return;
    }

    const style = document.createElement('style');
    style.textContent = `
      #chat-widget [role="button"][aria-label="Open chat"] {
        bottom: calc(20px + var(--gp-sticky-cart-height, 0px));
      }
      #chat-widget [data-gp-chat-icon] { position: relative; }
      #chat-widget [data-gp-chat-icon] > img { display: none; }
      #chat-widget [data-gp-chat-icon]::after {
        content: "";
        position: absolute;
        inset: 0;
        margin: auto;
        width: 28px;
        height: 28px;
        background: center / contain no-repeat url('data:image/svg+xml,${icon}');
        pointer-events: none;
      }
      #chat-widget [aria-label="Open chat"]:focus-visible {
        outline: 3px solid #232721;
        outline-offset: 4px;
        border-radius: 999px;
      }
      #chat-widget {
        max-height: calc(100dvh - var(--gp-sticky-cart-height, 0px) - var(--gp-chat-bottom-gap, 0px) - max(12px, env(safe-area-inset-top)));
      }
      @media (max-width: 767px) {
        #chat-widget {
          --gp-chat-left-gap: max(12px, env(safe-area-inset-left));
          --gp-chat-right-gap: max(12px, env(safe-area-inset-right));
          --gp-chat-bottom-gap: max(12px, env(safe-area-inset-bottom));
          box-sizing: border-box;
          width: calc(100% - var(--gp-chat-left-gap) - var(--gp-chat-right-gap));
          min-width: 0;
          max-width: 400px;
          left: auto;
          right: var(--gp-chat-right-gap);
          border-radius: 12px;
        }
        #chat-header, #chat-body, #chat-footer, #footer {
          min-width: 0;
        }
        #chat-input {
          min-width: 0;
          max-width: 100%;
          font-size: 16px;
        }
      }
    `;
    shadow.appendChild(style);

    function sync() {
      const widget = shadow.getElementById('chat-widget');
      // The vendor supplies an inline bottom value on the panel. Use the shared
      // bar-height variable at that same layer, without a CSS !important override.
      const bottom = 'calc(var(--gp-sticky-cart-height, 0px) + var(--gp-chat-bottom-gap, 0px))';
      if (widget && widget.style.bottom !== bottom) {
        widget.style.bottom = bottom;
      }
      const image = shadow.querySelector('[aria-label="Open chat"] img[alt="Open chat"]');
      if (image && !image.parentElement.hasAttribute('data-gp-chat-icon')) {
        image.parentElement.setAttribute('data-gp-chat-icon', '');
      }
    }

    const observer = new MutationObserver(sync);
    observer.observe(shadow, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    sync();
  }

  enhance();
})();
